module.exports = __webpack_public_path__ + "static/media/icon-checked-circle.17dcd64a.svg";